import {API, API_ROUTES} from "../../api";

const data = {
    namespaced: true,
    state: {
        user_roles: [],
        company_statuses: [],
        listing_statuses: [],
        license_types: [],
        category_types: [],
        categories: [],
        subcategories: [],
        strain_types: [],
        strains: [],
        production_types: [],
        shippers: [],
        order_statuses: [],
        order_types: [],
        order_sources: [],
        admin_notifications: []
    },
    mutations: {
        setUserRoles(state, value) {
            state.user_roles = value;
        },
        setCompanyStatuses(state, value) {
            state.company_statuses = value;
        },
        setListingStatuses(state, value) {
            state.listing_statuses = value;
        },
        setLicenseTypes(state, value) {
            state.license_types = value;
        },
        setCategoryTypes(state, value) {
            state.category_types = value;
        },
        setCategories(state, value) {
            state.categories = value;
        },
        setSubcategories(state, value) {
            state.subcategories = value;
        },
        setStrainTypes(state, value) {
            state.strain_types = value;
        },
        setStrains(state, value) {
            state.strains = value;
        },
        setProductionTypes(state, value) {
            state.production_types = value;
        },
        setOrderStatuses(state, value) {
            state.order_statuses = value;
        },
        setOrderTypes(state, value) {
            state.order_types = value;
        },
        setOrderSources(state, value) {
            state.order_sources = value;
        },
        setAdminNotifications(state, value) {
            state.admin_notifications = value;
        }
    },
    actions: {
        syncUserRoles({commit}) {
            API.get(API_ROUTES.ADMIN_USER_ROLES).then(({data}) => {
                commit('setUserRoles', data.user_roles);
            });
        },
        syncCompanyStatuses({commit}) {
            API.get(API_ROUTES.ADMIN_COMPANY_STATUSES).then(({data}) => {
                commit('setCompanyStatuses', data.company_statuses);
            });
        },
        syncListingStatuses({commit}) {
            API.get(API_ROUTES.ADMIN_LISTING_STATUSES).then(({data}) => {
                commit('setListingStatuses', data.listing_statuses);
            });
        },
        syncLicenseTypes({commit}) {
            API.get(API_ROUTES.ADMIN_LICENSE_TYPES).then(({data}) => {
                commit('setLicenseTypes', data.license_types);
            });
        },
        syncCategoryTypes({commit}) {
            API.get(API_ROUTES.TAXONOMY_CATEGORY_TYPES).then(({data}) => {
                commit('setCategoryTypes', data.category_types);
            });
        },
        syncCategories({commit}) {
            API.get(API_ROUTES.TAXONOMY_CATEGORIES).then(({data}) => {
                commit('setCategories', data.categories);
            });
        },
        syncSubcategories({commit}) {
            API.get(API_ROUTES.TAXONOMY_SUBCATEGORIES).then(({data}) => {
                commit('setSubcategories', data.subcategories);
            });
        },
        syncStrainTypes({commit}) {
            API.get(API_ROUTES.TAXONOMY_STRAIN_TYPES).then(({data}) => {
                commit('setStrainTypes', data.strain_types);
            });
        },
        syncStrains({commit}) {
            API.get(API_ROUTES.TAXONOMY_STRAINS).then(({data}) => {
                commit('setStrains', data.strains);
            });
        },
        syncProductionTypes({commit}) {
            API.get(API_ROUTES.TAXONOMY_PRODUCTION_TYPES).then(({data}) => {
                commit('setProductionTypes', data.production_types);
            });
        },
        syncOrderStatuses({commit}) {
            API.get(API_ROUTES.ADMIN_ORDER_STATUSES).then(({data}) => {
                commit('setOrderStatuses', data.order_statuses);
            });
        },
        syncOrderTypes({commit}) {
            API.get(API_ROUTES.ADMIN_ORDER_TYPES).then(({data}) => {
                commit('setOrderTypes', data.order_types);
            });
        },
        syncOrderSources({commit}) {
            API.get(API_ROUTES.ADMIN_ORDER_SOURCES).then(({data}) => {
                commit('setOrderSources', data.order_sources);
            });
        },
        syncAdminNotifications({commit}) {
            API.get(`${API_ROUTES.ADMIN_USERS}/admin-notifications`).then(({data}) => {
                commit('setAdminNotifications', data.notification_classes);
            });
        }
    }
}

export default data;
